import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLOSE_LOCAL_360, OPEN_LOCAL_360 } from './actions';
const initialState = {
    isOpen: false
};
ReducerRegistry.register('features/local-360', (state = initialState, action) => {
    switch (action.type) {
        case OPEN_LOCAL_360:
            return {
                isOpen: true,
                videoId: action.videoId
            };
        case CLOSE_LOCAL_360:
            return initialState;
        default:
            return state;
    }
});
